import {MARBLE_MARKETS, RACING_MARKETS} from '../modules/racing/constants/identifiers';
import {FOOTBALL_MARKETS} from '../modules/football/constants/identifiers';
import {FIRST_DOWN_MARKETS} from '../modules/firstDown/constants/identifiers';
import {AWAY, BOTH, FOOTBALL, HOME, SOCCER3_FOOTBALL} from "../../../constants/identifiers";
import {ALL_BASKETBALL_MARKETS} from "../../sports-book/modules/basketball/constants/marketTypes";
import {AMERICAN_FOOTBALL_MARKETS} from "../../simplified/modules/americanFootball/constants/identifiers";
import {MATCHDAY_MARKETS} from '../modules/matchday/constants/identifiers';
import {CRICKET_MARKETS} from "../modules/cricket/constants/identifiers";
import {ALL_TENNIS_MARKETS} from "../modules/tennis/constants/marketTypes";

export function getRacingMarketNameByCode(code) {
    let market = RACING_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function getMarbleMarketNameByCode(code) {
    let market = MARBLE_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function getFootballMarketNameByCode(code) {
    let market = FOOTBALL_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function getBasketballMarketNameByCode(code) {
    let market = ALL_BASKETBALL_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function getAFMarketNameByCode(code) {
    let market = AMERICAN_FOOTBALL_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function getFirstDownMarketNameById(id) {
    id = id.replace('_', '-');
    let market = FIRST_DOWN_MARKETS.find((mkt) => mkt.ids.includes(id));

    if (market) {
        return market.name;
    }
}

export function isHomeOrAwayTeamBet(bet) {
    if (bet.EventType !== FOOTBALL || bet.EventType !== SOCCER3_FOOTBALL) return;

    switch (bet.Market.Id.split('_')[0]) {
        case '9':
            if (bet.Market.Id.split('_')[1] === '0') return HOME;
            if (bet.Market.Id.split('_')[1] === '1') return BOTH;
            if (bet.Market.Id.split('_')[1] === '2') return AWAY;
            break;
        case '26':
        case '35':
            return HOME;
        case '27':
        case '36':
            return AWAY;
        case '28':
            return BOTH;
        default:
            return '';
    }
}

export function isTeamUsingHomeKit(bet, team) {
    return bet.EventDetails.team1 === team;
}

export function getMatchDayMarketNameByCode(code) {
    let market = MATCHDAY_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}
export function getCricketMarketNameByCode(code) {
    let market = CRICKET_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}
export function getTennisOrBaseballMarketName(code,mktList) {
    let market = mktList.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function isAlternativeKit(value) {
    if (typeof value !== "undefined" && value !== null) {
      return value.toString() === '1';
    } else {
      return false;
    }
  }


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/helpers/marketHelpers.js